<lib-sticky-modal>
  <lib-sticky-header>
    <app-collection-displays-modal-header [title]="'Template Collection Displays'" [showClearButton]="false">
    </app-collection-displays-modal-header>
  </lib-sticky-header>
  <lib-sticky-body>
    <div class="required-display-edit-method-container">
      <app-arrow-button
        *ngFor="let editMethod of viewModel.editMethods$ | async"
        [title]="editMethod?.title"
        [subtitle]="editMethod?.subtitle"
        [titleFontSize]="'0.75rem'"
        [subtitleFontSize]="'0.75rem'"
        [titleFontWeight]="'500'"
        [subtitleFontWeight]="'400'"
        (clicked)="editMethodSelected.emit(editMethod.type)">
      </app-arrow-button>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <app-go-back-modal-footer
      [includeStickyFooterContainerClass]="false"
      (cancelClicked)="cancelClicked.emit()"
      [showBackButton]="false"
      [showPrimaryButton]="false">
    </app-go-back-modal-footer>
  </lib-sticky-footer>
</lib-sticky-modal>
